import { apiSlice } from '../../api/apiSlice';
import { RoleByIdParams, RoleListResponse } from './roleByIdApiSliceTypes';

const roleByIdApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getRoleById: builder.query<RoleListResponse, RoleByIdParams>({
            query: (params) => {
                const { roleId, ...queryParams } = params ?? {};

                return {
                    url: `/roles/${roleId}`,

                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                    params: {
                        ...queryParams,
                    },
                };
            },
            providesTags: (result, error, params) =>
                result ? [{ type: 'roles', id: params.roleId }] : [],
        }),
    }),
    overrideExisting: true,
});

export const { useGetRoleByIdQuery, useLazyGetRoleByIdQuery } =
    roleByIdApiSlice;
